module.exports = __webpack_public_path__ + "static/media/MARAM BAKHET.a63be05e.png";